
import { defineComponent, PropType } from "vue";
import GraphDonut from "./GraphDonut.vue";
import { DonutDefinition } from "@/helpers/typesDefinition";

type StyledLabel = {
  name: string;
  value: string;
  style?: string;
};

export default defineComponent({
  props: {
    donutDefinition: Object as PropType<DonutDefinition>,
    labels: Object as PropType<StyledLabel[]>,
  },
  components: {
    GraphDonut,
  },
});
